var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import { runtime } from '../../../classes/runtime/Runtime';
import { AvailablePopover } from '../../../components/other/AvailablePopover';
let MenubarUserEmail = class MenubarUserEmail extends React.PureComponent {
    get buttonTextColor() {
        const { app } = this.props;
        if (app.menubarUser.isUserMenuOpen)
            return '#fff';
        if (app.menubarUser.isUserMenuButtonHovered)
            return '#adadad';
        return '#9d9d9d';
    }
    get displayUserString() {
        const { app } = this.props;
        if (!app.user)
            return '';
        return app.user.displayUserString;
    }
    render() {
        const { app } = this.props;
        if (!runtime.streamedPackages.Lazy)
            return null;
        return (React.createElement(AvailablePopover, { placement: "right", content: "Account-Funktionen" },
            React.createElement("div", { style: {
                    minWidth: 175,
                    maxWidth: 210,
                    display: 'flex',
                    paddingLeft: 3,
                    marginTop: -3,
                    color: this.buttonTextColor,
                }, onClick: app.menubarUser.toggleMenu },
                React.createElement("span", { style: {
                        fontSize: 13,
                        display: 'inline-block',
                        whiteSpace: 'nowrap',
                        flex: '1 1 auto',
                        fontFamily: '"Roboto Condensed", sans-serif',
                        textShadow: 'rgba(0, 0, 0, 0.25) 0px -1px 0px',
                    }, onMouseEnter: action(() => {
                        app.menubarUser.isUserMenuButtonHovered = true;
                        const preloadSiblings = app.menubarUser.menubarUserSiblings.siblingsData.streamedRef;
                    }), onMouseOut: action(() => (app.menubarUser.isUserMenuButtonHovered = false)) }, this.displayUserString),
                React.createElement("span", { style: { marginLeft: 10, fontSize: 11, transform: 'scale(1, 0.6)', marginTop: 2 } }, "\u25BC"))));
    }
};
MenubarUserEmail = __decorate([
    observer
], MenubarUserEmail);
export { MenubarUserEmail };
